var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLengthTypeRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "411px",
    height: "571px",
    viewBox: "0 0 411 571",
    enableBackground: "new 0 0 411 571",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 65.4,
    y: 55,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 3,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 78.1,
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    width: 234,
    height: 342.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.1,
    y: 0,
    fill: "#B2B2B2",
    stroke: "#706F6F",
    strokeWidth: 1.2906,
    strokeMiterlimit: 10,
    width: 408.8,
    height: 6.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M204.1,9.5v547.1h0.2c1.1,3,7.2,5.3,14.7,5.3s13.6-2.3,14.7-5.3 h0.2V9.5H204.1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#878787",
    strokeMiterlimit: 10,
    d: "M204.1,37.7c0,0,11.8,6.5,29.8,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M233.8,9.5v547.1h0.2c1.1,3,7.2,5.3,14.7,5.3 c7.5,0,13.6-2.3,14.7-5.3h0.2V9.5H233.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#878787",
    strokeMiterlimit: 10,
    d: "M233.8,37.7c0,0,11.8,6.5,29.8,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M263.6,9.5v547.1h0.2c1.1,3,7.2,5.3,14.7,5.3 c7.5,0,13.6-2.3,14.7-5.3h0.2V9.5H263.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#878787",
    strokeMiterlimit: 10,
    d: "M263.6,37.7c0,0,11.8,6.5,29.8,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M293.3,9.5v547.1h0.2c1.1,3,7.2,5.3,14.7,5.3 c7.5,0,13.6-2.3,14.7-5.3h0.2V9.5H293.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#878787",
    strokeMiterlimit: 10,
    d: "M293.3,37.7c0,0,11.8,6.5,29.8,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M323.1,9.5v547.1h0.2c1.1,3,7.2,5.3,14.7,5.3 c7.5,0,13.6-2.3,14.7-5.3h0.2V9.5H323.1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#878787",
    strokeMiterlimit: 10,
    d: "M323.1,37.7c0,0,11.8,6.5,29.8,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M352.9,9.5v547.1h0.2c1.1,3,7.2,5.3,14.7,5.3 c7.5,0,13.6-2.3,14.7-5.3h0.2V9.5H352.9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#878787",
    strokeMiterlimit: 10,
    d: "M352.9,37.7c0,0,11.8,6.5,29.8,0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLengthTypeRight);
export default __webpack_public_path__ + "static/media/length_type_right.c7a9c79453161c8289ba25c0eac48f85.svg";
export { ForwardRef as ReactComponent };